import { React, useState, useEffect } from "react";
import { Button, Table, Input } from "antd";
import { FilterOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchCalibrations } from "utilities/redux/slices/calibrationsSlice";
import Footer from "components/Footer";
import FilterModal from "../shared/FilterModal";
import PrintButton from "./components/PrintButton";
import useRoleCheck from "utilities/hooks/roleCheck";
import ForbiddenScreen from "pages/403";

const Calibrations = () => {
  const { hasPermission } = useRoleCheck();
  const dispatch = useDispatch();

  const calibrations = useSelector((state) => state.calibrations.data.data);
  const total = useSelector((state) => state.calibrations.data.total);

  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    clinics: []
  })

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [printVisible, setPrintVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchCalibrations({ search, filters }));
  }, [dispatch, search, filters])

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const columns = [
    {
      title: "Clinic",
      dataIndex: "clinicNo",
    },
    {
      title: "Category",
      dataIndex: "category",
      width: 300,
    },
    {
      title: "Brand",
      dataIndex: "brand",
    },
    {
      title: "Model",
      dataIndex: "model",
    },
    {
      title: "Calibration Date",
      dataIndex: "date",
      width: 200
    },
    {
      title: "Certificate",
      dataIndex: "",
      key: "x",
      width: 200,
      render: (record) => (
        (
          <Button
            href={record.certLink}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!record.certLink}
            icon={<DownloadOutlined />}
          >
            Download {!record.certLink ? "Certificate" : record.fileName}
          </Button>
        )
      )
    }
  ];

  if (
    !hasPermission([
      "Operations",
      "IT",
      "Marketing",
      "Sales.RM",
      "Sales.Exec",
      "Audiology",
    ])
  ) {
    return <ForbiddenScreen />;
  }

  return (
    <>
      <div className="p-8">
        <div className="flex">
          <Input.Search
            placeholder="Search Calibrations"
            allowClear
            size="large"
            onChange={handleSearch}
            className="mr-2"
          />
          <Button
            type="primary"
            size="large"
            icon={<FilterOutlined />}
            className="ml-2"
            onClick={() => setIsFilterModalVisible(true)}
          >
            Filter
          </Button>
          <Button
            type="primary"
            size="large"
            icon={<DownloadOutlined />}
            className="ml-2"
            onClick={() => setPrintVisible(true)}
          >
            Print
          </Button>
        </div>

        <div className="mt-4">
          <Table
            bordered
            columns={columns}
            dataSource={calibrations}
            rowKey={(record) => {
              return record.id + record.date;
            }}
            pagination={{
              total: total,
              showSizeChanger: true,
              onChange: (page, pageSize) => dispatch(fetchCalibrations({ search, filters, page, pageSize })),
            }}
          />
          <Footer />
        </div>
      </div>
      <FilterModal
        visible={isFilterModalVisible}
        setVisible={setIsFilterModalVisible}
        setFilters={setFilters}
      />
      <PrintButton
        search={search}
        filters={filters}
        visible={printVisible}
        setVisible={setPrintVisible}
      />
    </>
  );
};

export default Calibrations;